let context: AudioContext | null = null;

function audioContext() {
  if (typeof window === "undefined") return null;
  const AudioContextConstructor = window.AudioContext ?? (window as Window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!AudioContextConstructor) return null;
  context ??= new AudioContextConstructor();
  return context;
}

export async function primeReminderChime() {
  const current = audioContext();
  if (current?.state === "suspended") await current.resume().catch(() => undefined);
}

export async function playReminderChime() {
  const current = audioContext();
  if (!current) return;
  if (current.state === "suspended") await current.resume().catch(() => undefined);
  if (current.state !== "running") return;
  const startedAt = current.currentTime;
  [523.25, 659.25].forEach((frequency, index) => {
    const oscillator = current.createOscillator();
    const gain = current.createGain();
    oscillator.type = "sine";
    oscillator.frequency.value = frequency;
    gain.gain.setValueAtTime(0.0001, startedAt + index * 0.14);
    gain.gain.exponentialRampToValueAtTime(0.13, startedAt + index * 0.14 + 0.018);
    gain.gain.exponentialRampToValueAtTime(0.0001, startedAt + index * 0.14 + 0.32);
    oscillator.connect(gain).connect(current.destination);
    oscillator.start(startedAt + index * 0.14);
    oscillator.stop(startedAt + index * 0.14 + 0.34);
  });
}
